import mimeTypes from 'mime-types';

import UploadDragIcon from '~/shared/components/icons/lib/upload-drag-icon';

const FilesUploaderPlaceholder = ({
  maxBatchFilesSize,
  maxFileSize,
  maxNumberOfFiles,
  rootProps,
  t,
  inputProps,
  formats,
}) => {
  return (
    <div {...rootProps} className="files-uploader-field__input-area">
      <div>
        <div className="files-uploader-field__drag-info">
          <UploadDragIcon color="#EBCB2E" />
          <span>{t('button.drop-files-or-select-in-browser')}</span>
        </div>
        {formats?.length > 0 && (
          <div className="files-uploader-field__formats-block">
            <span>-</span>
            <span>{t('text.formats-that-maintained')}</span>
            <div>
              {formats?.map((format, i) => {
                let fileFormat = mimeTypes.extension(format);

                if (format === 'image/jpg') {
                  fileFormat = 'jpg';
                }

                return <span key={i}>{`${fileFormat}${i < formats?.length - 1 ? ', ' : ''}`}</span>;
              })}
            </div>
          </div>
        )}
        <div className="files-uploader-field__formats-block">
          <span>-</span>
          <span>
            {t('text.file-sizes-limit', {
              maxBatchFilesSize,
              maxFileSize,
              maxNumberOfFiles,
            })}
          </span>
        </div>
        <input {...inputProps} />
      </div>
    </div>
  );
};

export default FilesUploaderPlaceholder;
